import { Color, Vector3 } from "@phdsoft/three";
import * as THREE from "three";

export function getDataTexCriticalArea(): THREE.DataTexture {
  const side = 2;
  const amount = Math.pow(side, 2);
  const data = new Uint8Array(amount * 4);
  const center = new THREE.Vector2(.5, .5);

  for (var i = 0; i < amount; i++) {

    if (i === 0) {
      var stride = (i) * side / (side / 4);

      data[stride] = 255;// red
      data[stride + 1] = 255;// green
      data[stride + 2] = 0;// blue
      data[stride + 3] = 255;// alpha
    }
    else if (i === 1 || i === 2) {
      var stride = (i) * side / (side / 4);

      data[stride] = 255;// red
      data[stride + 1] = 0;// green
      data[stride + 2] = 0;// blue
      data[stride + 3] = 255;// alpha
    }
    else {
      stride = (i) * side / (side / 4);

      data[stride] = 255;// red
      data[stride + 1] = 255;// green
      data[stride + 2] = 0;// blue
      data[stride + 3] = 255;// alpha
    }

  }

  var dataTex = new THREE.DataTexture(data, side, side, THREE.RGBAFormat, THREE.UnsignedByteType);
  dataTex.center = center;
  //dataTex.rotation = 0.785;
  dataTex.wrapS = THREE.RepeatWrapping;
  dataTex.wrapT = THREE.RepeatWrapping;
  dataTex.repeat.set(1, 1);
  dataTex.generateMipmaps = true;
  dataTex.magFilter = THREE.NearestFilter;
  dataTex.needsUpdate = true;
  // console.log(dataTex)
  //debugger
  return dataTex
}

export function getDataTexSquared(): THREE.DataTexture {
  const side = 4;
  const amount = Math.pow(side, 2);
  const data = new Uint8Array(amount * 4);
  const center = new THREE.Vector2(.5, .5);

  for (var i = 0; i < amount; i++) {

    if (i % 2 === 0) {
      var stride = (i) * side / (side / 4);

      data[stride] = 255;// red
      data[stride + 1] = 255;// green
      data[stride + 2] = 0;// blue
      data[stride + 3] = 255;// alpha

    } else {
      stride = (i) * side / (side / 4);

      data[stride] = 255;// red
      data[stride + 1] = 0;// green
      data[stride + 2] = 0;// blue
      data[stride + 3] = 255;// alpha
    }

  }

  var dataTex = new THREE.DataTexture(data, side, side, THREE.RGBAFormat, THREE.UnsignedByteType);
  dataTex.center = center;
  dataTex.rotation = 0.785;
  dataTex.wrapS = THREE.RepeatWrapping;
  dataTex.wrapT = THREE.RepeatWrapping;
  dataTex.repeat.set(1, 1);
  dataTex.generateMipmaps = true;
  dataTex.magFilter = THREE.NearestFilter;
  dataTex.needsUpdate = true;
  //console.log(dataTex)
  //debugger
  return dataTex
}


export function getUVSValues(vertices: any, _target: any) {
  const vertexCount = vertices.length / 3;
  const uvs = new Float32Array(vertexCount * 3);
  for (let i = 0; i < vertexCount; i++) {
    let x = vertices[i * 3];
    let y = vertices[i * 3 + 1];
    let z = vertices[i * 3 + 2];
    //calculate UVs based on the positions
    const normal: Vector3 = _target.elementNormal.clone();
    normal.x = Math.abs(normal.x);
    normal.y = Math.abs(normal.y);
    normal.z = Math.abs(normal.z);

    if (normal.x >= normal.y && normal.x >= normal.z) {
      uvs[i * 3] = y;
      uvs[i * 3 + 1] = z;
      uvs[i * 3 + 2] = x;
    }
    else if (normal.y >= normal.x && normal.y >= normal.z) {
      uvs[i * 3] = z;
      uvs[i * 3 + 1] = x;
      uvs[i * 3 + 2] = y;
    }
    else if (normal.z >= normal.x && normal.z >= normal.y) {
      uvs[i * 3] = x;
      uvs[i * 3 + 1] = y;
      uvs[i * 3 + 2] = z;
    }
  }

  return uvs;
}

export function getSquareTex(color1: Color, color2: Color): THREE.DataTexture {
  const side = 2;
  const amount = Math.pow(side, 2);
  const data = new Uint8Array(amount * 4);
  const center = new THREE.Vector2(.5, .5);

  for (var i = 0; i < amount; i++) {
    if (i === 1 || i === 2) {
      var stride = (i) * side / (side / 4);

      data[stride] = color1.r * 255;// red
      data[stride + 1] = color1.g * 255;// green
      data[stride + 2] = color1.b * 255;// blue
      data[stride + 3] = 255;// alpha
    }
    else {
      var stride = (i) * side / (side / 4);

      data[stride] = color2.r * 255;// red
      data[stride + 1] = color2.g * 255;// green
      data[stride + 2] = color2.b * 255;// blue
      data[stride + 3] = 255;// alpha
    }
  }

  var dataTex = new THREE.DataTexture(data, side, side, THREE.RGBAFormat, THREE.UnsignedByteType);
  dataTex.center = center;
  dataTex.wrapS = THREE.RepeatWrapping;
  dataTex.wrapT = THREE.RepeatWrapping;
  dataTex.repeat.set(1, 1);
  dataTex.generateMipmaps = true;
  dataTex.magFilter = THREE.NearestFilter;
  dataTex.needsUpdate = true;
  return dataTex
}
